<template>
  <div class="main-container">
    <router-view></router-view>

    <!-- Navbar section -->
    <HeaderStartup />

    <!-- hero section -->
    <HeroStartup />

    <!-- service area  -->
    <CurveShape class="no-height">
      <template v-slot:bgcolor>
        <path
          style="fill: #ffffff; stroke-miterlimit: 10"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
    <div
      class="start-ups-feature startup-about-feature section-space--pt_120"
      id="about"
    >
      <div class="container">
        <div class="section-title-wrapper text-center section-space--mb_60">
          <h2 class="section-title mb-30 wow move-up">
            Proprietary Data-Driven Evolutive Risk Management System 
          </h2>
          <div class="video-button-container video-popup wow move-up">
            <div class="video-play">
              <span class="video-text"
                >The Coinonia team utilizes a proprietary learning-based risk management algorithm combined with data-driven trading systems to support our commitment to continuously uncover new trading opportunities and optimize our edge in the market. Through the collection, analysis and application of 100+ data points for every trade, our Playbook of trade systems is constantly learning, improving and adapting to market conditions.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- contact form section -->
    <!-- <ContactForm /> -->
    <div class="section-space--ptb_120 bg-gray-3" id="contact">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="digital-agency-section-title text-center section-space--mb_60">
                        <h3 class="section-title font-weight--light mb-15 wow move-up">Get in touch:</h3>
                    </div>
                    <!-- newsletter text -->
                    <h4 class="sub-heading text-center wow move-up"><a href="mailto:info@coinoniatrading.com" class="hover-style-link hover-style-link--green">info@coinoniatrading.com</a></h4>
                </div>
            </div>
        </div>
    </div>

    <!-- footer section -->
    <!-- <FooterMain FooterStyle="bg_drak-footer" /> -->
  </div>
</template>

<script>
import HeaderStartup from "../components/HeaderStartup";
import HeroStartup from "../components/HeroStartup";
import CurveShape from "../components/CurveShape";
// import ContactForm from "../components/ContactForm";
// import FooterMain from "../components/FooterMain";

export default {
  name: "app",
  components: {
    HeaderStartup,
    HeroStartup,
    CurveShape,
    // ContactForm,
    // FooterMain,
    
  },
  data (){
      return {}
  },
  metaInfo: {
    title: "Coinonía Trading",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
};
</script>